// ==============================================
// ===================Imports====================
// ==============================================
// ==============================================

// =================ACTIONS=====================
import { SET_LOADING_FOOTER, SET_SAVE_DATA_FOOTER } from '../actions/footer';

// ==============================================
// ================InitialState==================
// ==============================================

const initialState = {
  loadingFooter: true,
  data: [],
};

function footerReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_LOADING_FOOTER:
      return {
        ...state,
        loadingFooter: action.value,
      };
    case SET_SAVE_DATA_FOOTER:
      return {
        ...state,
        data: action.value,
      };
    default:
      return state;
  }
}

export default footerReducer;
